module.exports = {
  publish: [
    {
      id: "publish-single",
      title: "Publish Single Document",
      iconClasses: "fa-solid fa-file",
      route: "#/publish/single",
    },
    {
      id: "publish-bulk",
      title: "Publish Documents in Bulk",
      iconClasses: "fa-solid fa-upload",
      route: "#/publish/bulk",
    },
    {
      id: "publish-badge",
      title: "Publish Badge",
      iconClasses: "fa-solid fa-file-certificate",
      route: "#/publish/badge",
    },
    // {
    //   id: "publish-status",
    //   title: "Document Status",
    //   iconClasses: "fa-solid fa-envelope",
    //   route: "#/publish/status",
    // },
  ],
  signing: [
    {
      id: "signing-multiSigner",
      title: "Doc Multi-Signer",
      iconClasses: "fa-solid fa-file-contract",
      route: "#/signing/multiSigner",
    },
    {
      id: "signing-dockets",
      title: "Dockets",
      iconClasses: "fa-solid fa-list",
      route: "#/signing/dockets",
    },
    {
      id: "signing-signer",
      title: "Signers",
      iconClasses: "fa-solid fa-user",
      route: "#/signing/signer",
    },
    {
      id: "signing-seal",
      title: "Seal",
      iconClasses: "fa-solid fa-seal",
      route: "#/signing/seal",
    },
  ],
  documents: [
    {
      id: "documents-single",
      title: "Published Documents",
      iconClasses: "fa-solid fa-file",
      route: "#/documents/single",
    },
    {
      id: "documents-bulk",
      title: "Bulk Sessions",
      iconClasses: "fa-solid fa-books",
      route: "#/documents/bulk",
    },
    {
      id: "documents-pending",
      title: "Pending Documents",
      iconClasses: "fa-solid fa-hourglass-clock",
      route: "#/documents/pending",
      // <i class="fa-solid fa-calendar-clock"></i>
    },
    {
      id: "documents-badge",
      title: "Badges",
      iconClasses: "fa-solid fa-file-certificate",
      route: "#/documents/badge",
    },
  ],
  analytics: [
    {
      id: "analytics-document",
      title: "Document Analytics",
      iconClasses: "fa-solid fa-file",
      route: "#/analytics/documents",
    },
    {
      id: "analytics-email",
      title: "Email Analytics",
      iconClasses: "fa-solid fa-envelope",
      route: "#/analytics/email",
    },
  ],
  templates: [
    {
      id: "templates-document",
      title: "Document Templates",
      iconClasses: "fa-solid fa-file",
      route: "#/templates/document",
    },
    {
      id: "templates-file",
      title: "File Design Templates",
      iconClasses: "fa-solid fa-image",
      route: "#/templates/file",
    },
    {
      id: "templates-email",
      title: "Email Templates",
      iconClasses: "fa-solid fa-envelope",
      route: "#/templates/email",
    },
    {
      id: "templates-badge",
      title: "Badge Design Templates",
      iconClasses: "fa-solid fa-file-certificate",
      route: "#/templates/badge",
    },
  ],
  settings: [
    {
      id: "settings-home",
      title: "Menu",
      iconClasses: "fa-solid fa-house",
      route: "#/settings/integration/home",
    },
    {
      id: "settings-Integration",
      title: "2F Authentication",
      iconClasses: "fa-solid fa-shield-check",
      route: "#/settings/integration/authenticator",
    },
    {
      id: "settings-Security",
      title: "Change Password",
      iconClasses: "fa-solid fa-lock",
      route: "#/settings/security",
    },
  ],
}
